import { ApiResponseNHL, useFetchLeagueData } from '~/core/api';

import { Scores } from './types';

export const useScoreQuery = (date: string): ApiResponseNHL<Scores> => useFetchLeagueData(`/score/${date}`);
